// react
import React from 'react';

// third-party
import PropTypes from 'prop-types';

// application
import BlockHeader from '../shared/BlockHeader';
import ProductCard from '../shared/ProductCard';
import ProductCardSkeleton from '../shared/ProductCardSkeleton';

export default function BlockProducts(props) {
    const {
        title,
        layout,
        featuredProduct,
        products,
        loading,
    } = props;

    const isLoading = loading || (!featuredProduct && (!products || products.length === 0));

    if (isLoading) {
        const largeSkeleton = (
            <div className="block-products__featured d-none d-md-block">
                <div className="block-products__featured-item">
                    <ProductCardSkeleton layout="grid-lg" />
                </div>
            </div>
        );

        const smallSkeletons = (
            <div className="block-products__list">
                {Array.from({ length: 6 }).map((_, index) => (
                    <div key={`skel-prod-${index}`} className="block-products__list-item">
                        <ProductCardSkeleton layout="grid-nl" />
                    </div>
                ))}
            </div>
        );

        return (
            <div className={`block block-products block-products--layout--${layout} block-products--loading`}>
                <div className="container">
                    <BlockHeader title={title} />
                    <div className="block-products__body">
                        {layout === 'large-first' && largeSkeleton}
                        {smallSkeletons}
                        {layout === 'large-last' && largeSkeleton}
                    </div>
                </div>
            </div>
        );
    }

    let large;
    let smalls;

    if (featuredProduct) {
        large = (
            <div className="block-products__featured d-none d-md-block">
                <div className="block-products__featured-item">
                    <ProductCard product={featuredProduct} layout="grid-lg" />
                </div>
            </div>
        );
    }

    if (products.length > 0) {
        const productsList = products.slice(0, 6).map((product, index) => (
            <div key={index} className="block-products__list-item">
                <ProductCard product={product} />
            </div>
        ));

        smalls = (
            <div className="block-products__list">
                {productsList}
            </div>
        );
    }

    return (
        <div className={`block block-products block-products--layout--${layout}`}>
            <div className="container">
                <BlockHeader title={title} />

                <div className="block-products__body">
                    {layout === 'large-first' && large}
                    {smalls}
                    {layout === 'large-last' && large}
                </div>
            </div>
        </div>
    );
}

BlockProducts.propTypes = {
    title: PropTypes.string.isRequired,
    featuredProduct: PropTypes.object,
    products: PropTypes.array,
    layout: PropTypes.oneOf(['large-first', 'large-last']),
    loading: PropTypes.bool,
};

BlockProducts.defaultProps = {
    products: [],
    layout: 'large-first',
    loading: false,
};
